import React from "react";

import { LogOut } from 'lucide-react';
import { useAuthDispatch, AUTH_ACTIONS} from '@app/contexts/AuthContext';
import { useNavigate } from "react-router-dom";

export default function SectionTop() {
    const authDispatch = useAuthDispatch();    
    const navigate = useNavigate();

    function logout() {
        // Reset the context datas
        authDispatch({
            type: AUTH_ACTIONS.LOGOUT
        });

        // Redirection to the home page
        navigate('/sign-in');
    }

    return (
        <div className="section-top">
            <div className="logout" onClick={logout}>
                <LogOut color="#E3E8EF" />
                <span>Déconnexion</span>
            </div>
        </div>
    )
}